import client, { serviceClient } from 'lib/api/client';
import { AUTH_BASIC } from 'lib/constant/api';

export const getMasterUsers = () => serviceClient.get('/user/master');

export const updateMasterKid = ({ id, name, code, tel }) =>
  serviceClient.post(
    `/user/kids/${id}`,
    { name, code, tel },
    {
      headers: {
        'X-Method-Override': 'PATCH',
      },
    },
  );

export const resetMasterKid = ({ kidsUserId, password }) =>
  serviceClient.post(
    `/user/kids/${kidsUserId}/password`,
    {
      password,
    },
    {
      headers: {
        'X-Method-Override': 'PATCH',
      },
    },
  );

export const updatePassword = ({ id, password, level, type }) =>
  client.post(
    `/user/password`,
    {
      id,
      password,
      level,
      type,
    },
    {
      headers: {
        'X-Method-Override': 'PATCH',
      },
    },
  );

export const getUsers = (page, search, userType) =>
  serviceClient.get(
    `/user?page=${page}&limit=5&search=${search}&userType=${userType}`,
  );

export const getStoreList = () => serviceClient.get('/store/company');

export const inviteUser = ({ email, name, level, storeId }) =>
  serviceClient.post('/user/invite', {
    email,
    name,
    level,
    storeId,
  });

export const deleteInvite = ({ email, storeId }) =>
  serviceClient.post(
    '/user/invite',
    {
      email,
      storeId,
    },
    {
      headers: {
        'X-Method-Override': 'DELETE',
      },
    },
  );

export const permitUser = ({ storeId, userId, type }) =>
  serviceClient.post(
    '/user/permission',
    {
      storeId,
      userId,
      type,
    },
    {
      headers: {
        'X-Method-Override': 'PATCH',
      },
    },
  );

export const getLinkData = uuid =>
  client.get(`/user/invitation/${uuid}`, {
    headers: {
      Authorization: `${AUTH_BASIC}`,
    },
  });

export const checkId = emailId =>
  client.get(`/user/id?email=${emailId}`, {
    headers: {
      Authorization: `${AUTH_BASIC}`,
    },
  });

export const sendAuthMsg = (uuid, tel) =>
  client.post(
    `/user/invitation/${uuid}/sms`,
    { tel },
    {
      headers: {
        Authorization: `${AUTH_BASIC}`,
      },
    },
  );

export const sendAuthMsgPoC = (uuid, tel) =>
  client.post(
    `/user/invitation/${uuid}/sms`,
    { tel, type: 'seedn' },
    {
      headers: {
        Authorization: `${AUTH_BASIC}`,
      },
    },
  );

export const registerFromLink = (uuid, user) =>
  client.post(`/user/invitation/${uuid}`, user, {
    headers: {
      Authorization: `${AUTH_BASIC}`,
    },
  });
